<template>
  <main>
    <router-view :key="String($route.params.feature)" />
  </main>
</template>
